import { useMemo, useEffect } from "react";
import useMediaQuery from '@mui/material/useMediaQuery';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import SnackBarContainer from "./components/common/SnackBar";
import Routes from "./routes";
import { useDispatch, useSelector } from "react-redux";
import DarkTheme from "./helpers/theme/DarkTheme";
import LightTheme from "./helpers/theme/LightTheme";
import { set_dark_mode } from "./store/common/commonSlice";
import Stack from "@mui/material/Stack";
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import { get_company_details_by_domain } from "./store/user/userSlice";

import { setFavicon } from "./helpers/faviconUtils";

function App() {
  const dispatch = useDispatch();
  const prefersDarkMode = useMediaQuery('(prefers-color-scheme: dark)');
  const { dark_mode } = useSelector((state) => state.common);
  const { common_loading, company_details } = useSelector((state) => state.user);

  useEffect(() => {
    // dispatch(set_dark_mode(prefersDarkMode ? "dark" : "light"));
    dispatch(set_dark_mode(prefersDarkMode ? "light" : "light"));
    if (window.location.pathname !== '/page-403') {
      dispatch(get_company_details_by_domain(window.location.hostname));
    }
  }, [dispatch, prefersDarkMode]);

  useEffect(() => {
    if (company_details?.name) {
      document.title = company_details.name;
    }
    if (company_details?.company_logo) {
      setFavicon(company_details.company_logo);
    }
  }, [company_details]);

  const theme = useMemo(
    () => createTheme(dark_mode === "dark" ? DarkTheme : LightTheme),
    [dark_mode]
  );

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <SnackBarContainer />
      <Stack sx={{
        width: '100%',
        minHeight: '100vh',
        height: 'auto',
        // background : window.location.pathname.includes('/admin') ? 'inherit' : "linear-gradient(#FFFFFF 20%, #f5ad8bff 100%)"
        background: window.location.pathname.includes('/admin') ? 'inherit' : "#FFF5F2"
      }}>
        <Backdrop
          sx={(theme) => ({
            color: '#fff',
            zIndex: 99999
          })}
          open={common_loading}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
        <Routes />
      </Stack>
    </ThemeProvider>
  );
}

export default App;
